/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FindingType = {
    DependencyTrackVulnerability: 'DEPENDENCY_TRACK_VULNERABILITY',
    SbomMissingIdentifier: 'SBOM_MISSING_IDENTIFIER',
    SbomFormat: 'SBOM_FORMAT',
    NoDeepSbom: 'NO_DEEP_SBOM',
    SbomUploadFailure: 'SBOM_UPLOAD_FAILURE',
    ContentUnderstanding: 'CONTENT_UNDERSTANDING',
    ContentCriteriaEvaluation: 'CONTENT_CRITERIA_EVALUATION',
    SecurityAssessmentVulnerability: 'SECURITY_ASSESSMENT_VULNERABILITY',
    Manual: 'MANUAL',
    Other: 'OTHER'
} as const;
export type FindingType = typeof FindingType[keyof typeof FindingType];

